import { render, staticRenderFns } from "./CusDocDetail.vue?vue&type=template&id=030eae3d&scoped=true&"
import script from "./CusDocDetail.vue?vue&type=script&lang=js&"
export * from "./CusDocDetail.vue?vue&type=script&lang=js&"
import style0 from "./CusDocDetail.vue?vue&type=style&index=0&id=030eae3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030eae3d",
  null
  
)

export default component.exports